import * as _4 from 'lodash4';

export class APAdvisorText {
  constructor(private phxFeatureConfiguration: any) {}

  get advisorLabel() {
    return _4.get(
      this.phxFeatureConfiguration.read('student-platform.roles.advisor-title.lowercase'),
      'assignContent',
      'advisor'
    );
  }
}

angular.module('capability-ng-academic-planner').service('ngAPAdvisorText', APAdvisorText);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/servants/ap_advisor_text_servant.ts